import React from "react";
import PropTypes from "prop-types";
import { InputLabel } from "../../../../shared/InputLabel/InputLabel";
import { Input } from "../../../../shared/Input/Input";
import { InputError } from "../../../../shared/InputError/InputError";

export function InputText({
  label,
  value,
  placeholder,
  onChange,
  error,
  isDisabled = false,
  warning = undefined,
}) {
  return (
    <div>
      <InputLabel>{label}</InputLabel>
      <Input
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        isError={!!error}
        isDisabled={isDisabled}
      />
      {!!error && <InputError>{error}</InputError>}
      {!!warning && <InputError>{warning}</InputError>}
    </div>
  );
}

InputText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  warning: PropTypes.string,
  isDisabled: PropTypes.bool,
};
